import React from 'react';

import { arrayOf, node, oneOfType } from 'prop-types';

import BaseComponent from '../../.internal/BaseComponent';

/**
 * @deprecated
 */
export default class MobileMenuItem extends BaseComponent {
  render() {
    const { children } = this.props;

    return <div className="menu-card-content">{children}</div>;
  }
}

MobileMenuItem.propTypes = {
  children: oneOfType([node, arrayOf(node)])
};

MobileMenuItem.defaultProps = {
  children: undefined
};
